<template>
  <div class="news-and-footer">
    <div class="page_content">
      <h3>ビューティーワールド ジャパン 東京出展のお知らせ</h3>
      <br>

      <div class="news_image">
        <img src="/assets/img/bwj09_outline_cube_L_jp.jpg" alt="ビューティーワールドジャパン2026東京">
      </div>

      <p>
      ビューティーワールド ジャパン 東京に出展いたします。<br>
	昨年発売したばかりの業務用マシンDr-PRO MAXや店販用美容器Dr-PRO BEAUTY SECRET等を実際にお試しいただけます。<br>
        お気軽にご来場ください。
      </p>

      <p>
       会期：2026年5月18日（月）－20日（水）<br>
	時間：10:00－18:00（最終日は16:30まで）<br>
	会場：東京ビッグサイト 西1－4ホール、南1－4ホール(〒135-0063 東京都江東区有明３丁目１１−１)<br>
	出展社名：株式会社スカンジナビアサービス<br>
	ブース番号：W1-P033
<br>
      </p>

      <p class="reserve">
        事前予約はこちら：
        <a
          href="https://docs.google.com/forms/d/19HladIstnD9spBqWrO-qk0ybv6Q1IZbRBHjLps_T4Vs/edit"
          target="_blank"
          rel="noopener"
        >
          予約フォーム
        </a>
      </p>

      <footer2></footer2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'news20260518',
  components: {
    footer2: () => import('../components/Footer2.vue'),
  },
}
</script>

<style lang="scss" scoped>
.news-and-footer {
  margin-top: 80px;
}

.news_image {
  margin: 10px 0 25px;
}

.news_image img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}

.reserve a {
  text-decoration: underline;
}

@media (max-width: 600px) {
  .news-and-footer {
    margin-top: 30px;
  }
}
</style>

